<div class="flex min-h-screen w-full flex-col bg-[#F5F7F8] text-[#202A33]">
  <header class="sticky top-0 z-50 border-b border-[#DDE4E7] bg-white/85 backdrop-blur-xl">
   <nav class="mx-auto flex h-14 w-full max-w-360 items-center justify-between px-4 sm:px-6 lg:h-16 lg:px-8">
      <button (click)="scrollToSection('inicio')"
        type="button"
        class="cursor-pointer">
        <img src="/img/logoAltok.svg" alt="Logo Altok" class="h-5 w-auto lg:h-8" />
      </button>

      <div class="hidden items-center gap-8 text-sm md:flex">
        <button type="button"
          (click)="scrollToSection('como-funciona')"
          class="group relative cursor-pointer bg-transparent text-sm text-[#66727C] transition hover:text-[#202A33]">
          Como funciona
          <span class="absolute -bottom-1 left-0 h-px w-0 bg-[#4C7C89] transition-all duration-300 group-hover:w-full"></span>
        </button>

        <button type="button"
          (click)="scrollToSection('tarifas')"
          class="group relative cursor-pointer bg-transparent text-sm text-[#66727C] transition hover:text-[#202A33]">
          Tarifas
          <span class="absolute -bottom-1 left-0 h-px w-0 bg-[#4C7C89] transition-all duration-300 group-hover:w-full"></span>
        </button>

        <button type="button"
          (click)="scrollToSection('seguridad')"
          class="group relative cursor-pointer bg-transparent text-sm text-[#66727C] transition hover:text-[#202A33]">
          Seguridad
          <span class="absolute -bottom-1 left-0 h-px w-0 bg-[#4C7C89] transition-all duration-300 group-hover:w-full"></span>
        </button>

        <button type="button"
          (click)="scrollToSection('tarifas')"
          class="group relative cursor-pointer bg-transparent text-sm text-[#66727C] transition hover:text-[#202A33]">
          Contacto
          <span class="absolute -bottom-1 left-0 h-px w-0 bg-[#4C7C89] transition-all duration-300 group-hover:w-full"></span>
        </button>
      </div>

      <div class="hidden items-center gap-3 md:flex">
        <a routerLink="/login"
          class="group inline-flex cursor-pointer items-center gap-2 rounded-xl border border-[#DDE4E7] bg-white/80 px-4 py-2 transition hover:-translate-y-0.5 hover:bg-white hover:shadow-sm">
          <span class="inline-flex h-4 w-4 items-center justify-center">
            <img src="/img/icons/icon-key.svg" alt="" class="h-4 w-4 transition group-hover:scale-110" />
          </span>

          <span class="text-sm font-medium text-[#202A33]">
            Iniciar sesión
          </span> 
        </a>

        <a routerLink="/register"
          class="group inline-flex cursor-pointer items-center gap-2 rounded-xl bg-[#2F8A63] px-4 py-2 shadow-sm transition hover:-translate-y-0.5 hover:bg-[#267353] hover:shadow-md">
          <span class="inline-flex h-4 w-4 items-center justify-center">
            <img src="/img/icons/icon-person.svg" alt="" class="h-4 w-4 brightness-0 invert transition group-hover:scale-110" />
          </span>

          <span class="text-sm font-light text-white">
            Registrarse
          </span>
        </a>
      </div>
    </nav>
  </header>

  <main class="min-w-0 flex-1">
    <router-outlet />
  </main>

  <footer class="border-t border-[#DDE4E7] bg-white py-8 text-center text-sm text-[#66727C]">
    © 2026 AlTOK. Todos los derechos reservados.
  </footer>
</div>

<a
  href="https://wa.me/59171726832?text=Hola%2C%20quiero%20realizar%20una%20operaci%C3%B3n%20con%20Altok."
  target="_blank"
  rel="noopener noreferrer"
  aria-label="Escribir por WhatsApp"
  class="fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-[#25D366]/30 transition hover:-translate-y-1 hover:scale-105 hover:shadow-2xl"
>
  <img
    src="/img/icons/icon-chat.svg"
    alt=""
    class="h-7 w-7 brightness-0 invert"
  />
</a>